/**
 * Direct EmailJS API client — bypasses the @emailjs/browser SDK bug
 * where response body stream is read twice on error responses.
 */

const EMAILJS_API = "https://api.emailjs.com/api/v1.0/email/send";

export async function sendEmail(serviceId, templateId, templateParams, publicKey) {
  const response = await fetch(EMAILJS_API, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      service_id: serviceId,
      template_id: templateId,
      user_id: publicKey,
      template_params: templateParams,
    }),
  });

  if (!response.ok) {
    let errorMsg = `EmailJS error (${response.status})`;
    try {
      const text = await response.text();
      if (text) errorMsg = text;
    } catch {}
    throw new Error(errorMsg);
  }

  return { status: response.status, text: "OK" };
}
